import { Component, DOCUMENT, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationEnd, Router } from '@angular/router';
import { FacilityInformationType } from '@cargos/sprintpay-services';
import { Subject, filter, takeUntil } from 'rxjs';
import { ColumnsType } from 'src/app/shared/models';

@Component({
    selector: 'app-footer-table',
    templateUrl: './footer-table.component.html',
    styleUrls: ['./footer-table.component.scss'],
    standalone: false,
})
export class FooterTableComponent implements OnInit, OnDestroy {
    public dataTable: MatTableDataSource<FacilityInformationType>;

    @Input() columns: ColumnsType<FacilityInformationType>[];
    @Input() displayedColumns: string[];
    @Input()
    set dataSource(dataSource: FacilityInformationType[]) {
        this.dataTable = new MatTableDataSource<FacilityInformationType>(dataSource);
    }
    @Input() url: string;
    @Input() enableButton = true;
    @Input() enableColumns = true;

    private unsubscribe$: Subject<void>;

    constructor(
        private router: Router,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeRouter();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    goToFailityInfo(): void {
        const matSidenavContent = this.document.querySelector('mat-sidenav-content');
        if (matSidenavContent) {
            matSidenavContent.scrollTop = 0;
        }
        this.router.navigate([`/${this.url}`]);
    }

    subscribeRouter(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((event) => {
                if (!this.enableButton) {
                    this.enableButton = false;
                } else {
                    this.enableButton = !event['url'].includes(this.url);
                }
            });
    }
}
